import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { trackEvents } from "@/common/events/events";
import useContactNumbers from "@hooks/useContactNumbers";
var OIL_PAYMENT_SUMMARY_KEY = "oil_cart_payment_summary";
var ErrorIcon = function ErrorIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "10",
    y: "10",
    width: "34",
    height: "44",
    rx: "4",
    stroke: "#F04438",
    strokeWidth: "2.5",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 22h18M18 30h14M18 38h10",
    stroke: "#F04438",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "46",
    cy: "46",
    r: "11",
    fill: "#feeaea"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "46",
    cy: "46",
    r: "10",
    stroke: "#F04438",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 42l8 8M50 42l-8 8",
    stroke: "#F04438",
    strokeWidth: "2.5",
    strokeLinecap: "round"
  }));
};
var OilPaymentFailed = function OilPaymentFailed(_ref) {
  var onRetry = _ref.onRetry;
  var _useTranslation = useTranslation(["web_oils"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  useEffect(function () {
    if (__IS_CSR__) {
      var _params$get, _summary$payment_meth, _params$get2, _params$get3;
      var params = new URLSearchParams(window.location.search);
      var sourceType = (_params$get = params.get("source_type")) !== null && _params$get !== void 0 ? _params$get : "";
      var paymentMethod = sourceType === "applepay" ? "apple_pay" : "visa";
      var stored = localStorage.getItem(OIL_PAYMENT_SUMMARY_KEY);
      var summary = stored ? JSON.parse(stored) : {};
      trackEvents("vas_payment_failed", {
        payment_method: (_summary$payment_meth = summary.payment_method) !== null && _summary$payment_meth !== void 0 ? _summary$payment_meth : paymentMethod,
        failure_reason: (_params$get2 = params.get("message")) !== null && _params$get2 !== void 0 ? _params$get2 : "",
        error_code: (_params$get3 = params.get("id")) !== null && _params$get3 !== void 0 ? _params$get3 : ""
      });
      localStorage.removeItem(OIL_PAYMENT_SUMMARY_KEY);
    }
  }, []);
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  var handleRetry = function handleRetry() {
    if (onRetry) {
      onRetry();
    } else {
      navigateToHard("/site/cart");
    }
  };
  var contactNumbers = useContactNumbers();
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-white border border-[#ebf0f7] rounded-2xl shadow-[0px_1px_1px_rgba(0,0,0,0.08)] p-10 flex flex-col items-center gap-12 w-full",
    dir: "rtl"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center gap-6 w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-[#feeaea] p-2 rounded-2xl flex items-center justify-center"
  }, /*#__PURE__*/React.createElement(ErrorIcon, null)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center gap-4 text-center"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-[#00143c] font-bold text-[24px] leading-8"
  }, tShort("payment_status/failed_title", {
    ns: "web_oils"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#6c7a8d] text-[18px] leading-7 tracking-[-0.45px] max-w-[307px]"
  }, tShort("payment_status/failed_subtitle", {
    ns: "web_oils"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("button", {
    className: "bold-none w-full bg-[#0d0db5] text-white font-bold text-[16px] leading-6 rounded-[5px] h-14 px-8 cursor-pointer",
    onClick: handleRetry
  }, tShort("payment_status/retry", {
    ns: "web_oils"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2 items-center w-full"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-[#00143c] text-[16px] leading-6 text-center tracking-[-0.4px]"
  }, tShort("payment_status/need_help", {
    ns: "web_oils"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center gap-2 flex-row-reverse"
  }, /*#__PURE__*/React.createElement("a", {
    href: "tel:".concat(contactNumbers.callCenterCallNumber, ", { ns: \"web_oils\" })}"),
    className: "text-[#0d0db5] font-bold text-[18px] leading-7 tracking-[-0.45px]"
  }, contactNumbers.callCenterDisplayNumber), /*#__PURE__*/React.createElement("p", {
    className: "text-[#00143c] text-[14px] leading-5 tracking-[-0.35px]"
  }, tShort("payment_status/contact_us", {
    ns: "web_oils"
  })))));
};
export default OilPaymentFailed;